"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbortSignal = exports.AbortController = exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _eventTargetShim = require("./event-target-shim"); // This is adopted from abort-controller@3.0.0 under MIT License.
// The source code is copied here because the original package do not support ES5 browsers.
// https://github.com/mysticatea/abort-controller/blob/master/dist/abort-controller.mjs

/* eslint-disable */

/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 * See LICENSE file in root directory for full license.
 */

/**
 * The signal class.
 * @see https://dom.spec.whatwg.org/#abortsignal
 */


var AbortSignal = /*#__PURE__*/function (_EventTarget) {
  (0, _inherits2.default)(AbortSignal, _EventTarget);
  /**
   * AbortSignal cannot be constructed directly.
   */

  function AbortSignal() {
    var _this;

    (0, _classCallCheck2.default)(this, AbortSignal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AbortSignal).call(this));
    throw new TypeError('AbortSignal cannot be constructed directly');
    return _this;
  }
  /**
   * Returns `true` if this `AbortSignal`'s `AbortController` has signaled to abort, and `false` otherwise.
   */


  (0, _createClass2.default)(AbortSignal, [{
    key: "aborted",
    get: function get() {
      var aborted = abortedFlags.get(this);

      if (typeof aborted !== 'boolean') {
        throw new TypeError("Expected 'this' to be an 'AbortSignal' object, but got ".concat(this === null ? 'null' : (0, _typeof2.default)(this)));
      }

      return aborted;
    }
  }]);
  return AbortSignal;
}(_eventTargetShim.EventTarget);

exports.AbortSignal = AbortSignal;
(0, _eventTargetShim.defineEventAttribute)(AbortSignal.prototype, 'abort');
/**
 * Create an AbortSignal object.
 */

function createAbortSignal() {
  var signal = Object.create(AbortSignal.prototype);

  _eventTargetShim.EventTarget.call(signal);

  abortedFlags.set(signal, false);
  return signal;
}
/**
 * Abort a given signal.
 */


function abortSignal(signal) {
  if (abortedFlags.get(signal) !== false) {
    return;
  }

  abortedFlags.set(signal, true);
  signal.dispatchEvent({
    type: 'abort'
  });
}
/**
 * Aborted flag for each instances.
 */


var abortedFlags = new WeakMap(); // Properties should be enumerable.

Object.defineProperties(AbortSignal.prototype, {
  aborted: {
    enumerable: true
  }
}); // `toString()` should return `"[object AbortSignal]"`

if (typeof Symbol === 'function' && (0, _typeof2.default)(Symbol.toStringTag) === 'symbol') {
  Object.defineProperty(AbortSignal.prototype, Symbol.toStringTag, {
    configurable: true,
    value: 'AbortSignal'
  });
}
/**
 * The AbortController.
 * @see https://dom.spec.whatwg.org/#abortcontroller
 */


var AbortController = /*#__PURE__*/function () {
  /**
   * Initialize this controller.
   */
  function AbortController() {
    (0, _classCallCheck2.default)(this, AbortController);
    signals.set(this, createAbortSignal());
  }
  /**
   * Returns the `AbortSignal` object associated with this object.
   */


  (0, _createClass2.default)(AbortController, [{
    key: "abort",

    /**
     * Abort and signal to any observers that the associated activity is to be aborted.
     */
    value: function abort() {
      abortSignal(getSignal(this));
    }
  }, {
    key: "signal",
    get: function get() {
      return getSignal(this);
    }
  }]);
  return AbortController;
}();
/**
 * Associated signals.
 */


exports.AbortController = AbortController;
var signals = new WeakMap();
/**
 * Get the associated signal of a given controller.
 */

function getSignal(controller) {
  var signal = signals.get(controller);

  if (signal == null) {
    throw new TypeError("Expected 'this' to be an 'AbortController' object, but got ".concat(controller === null ? 'null' : (0, _typeof2.default)(controller)));
  }

  return signal;
} // Properties should be enumerable.


Object.defineProperties(AbortController.prototype, {
  signal: {
    enumerable: true
  },
  abort: {
    enumerable: true
  }
});

if (typeof Symbol === 'function' && (0, _typeof2.default)(Symbol.toStringTag) === 'symbol') {
  Object.defineProperty(AbortController.prototype, Symbol.toStringTag, {
    configurable: true,
    value: 'AbortController'
  });
}

var _default = AbortController;
exports.default = _default;